"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactUse = require("react-use");
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _string = require("../../_utils/string");
var MenuS = _interopRequireWildcard(require("./MenuStyles"));
var _MenuItemsList = _interopRequireWildcard(require("./MenuItemsList"));
var _ToggleMenuItem = _interopRequireDefault(require("./ToggleMenuItem"));
var _LogoutMenuItem = _interopRequireDefault(require("./LogoutMenuItem"));
var _MenuSearch = _interopRequireDefault(require("./MenuSearch"));
var _WhiteLabel = _interopRequireDefault(require("./WhiteLabel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var propTypes = {
  /** Initial state for the menu */
  initialOpen: _propTypes["default"].bool,
  /** A React component for the logo */
  logo: _propTypes["default"].any,
  /** An array of menu items */
  menuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape(_MenuItemsList.menuItemShape)),
  /** Menu has search field */
  hasSearch: _propTypes["default"].bool,
  /** The logout button exists in menu */
  hasLogoutButton: _propTypes["default"].bool,
  /** The function that will be called when logout menu item. Should logout the current user. */
  logout: _propTypes["default"].func,
  /** The image source and description for white-labeling or false if no logo */
  whiteLabel: _propTypes["default"].shape({
    /** Source for the white label when menu is open (expanded) */
    src: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
    /** Source for the white label when menu is closed (collapsed) */
    srcCollapsed: _propTypes["default"].string,
    /** Alt text */
    alt: _propTypes["default"].string
  }),
  /** Styling props for the Menu WhiteLabel. They would get set for each project's menu when implementing the design. */
  whiteLabelProps: _propTypes["default"].object
};
exports.propTypes = propTypes;
var searchInFields = ["path", "text"];
var Menu = function Menu(_ref) {
  var _ref$initialOpen = _ref.initialOpen,
    initialOpen = _ref$initialOpen === void 0 ? false : _ref$initialOpen,
    logo = _ref.logo,
    menuItems = _ref.menuItems,
    hasSearch = _ref.hasSearch,
    hasLogoutButton = _ref.hasLogoutButton,
    logout = _ref.logout,
    whiteLabel = _ref.whiteLabel,
    whiteLabelProps = _ref.whiteLabelProps;
  var _useLocalStorage = (0, _reactUse.useLocalStorage)("smalt_menu_is_open", initialOpen),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    isOpen = _useLocalStorage2[0],
    setIsOpen = _useLocalStorage2[1];
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var toggleMenu = function toggleMenu() {
    return setIsOpen(!isOpen);
  };
  var openMenu = function openMenu() {
    return setIsOpen(true);
  };
  var displayItems = (0, _react.useMemo)(function () {
    // If route is found, add isHighlighted to menuItem and submenuItem
    var highlightedMenuItems = menuItems;
    if (searchValue) {
      highlightedMenuItems = highlightedMenuItems.map(function (item) {
        // Deep cloning is necessary to prevent modifying the original item.
        // If the original item were to be modified, multiple items could wrongly appear selected at the same time.
        item = (0, _cloneDeep["default"])(item);
        if (item.submenuItems) {
          item.submenuItems = item.submenuItems.map(function (subItem) {
            if ((0, _string.matchWords)({
              query: searchValue,
              doc: subItem,
              fields: searchInFields
            })) {
              // query matched on child menu item
              subItem = (0, _cloneDeep["default"])(subItem);
              subItem.isHighlighted = true;
            }
            return subItem;
          });
        }
        if ((0, _string.matchWords)({
          query: searchValue,
          doc: item,
          fields: searchInFields
        })) {
          // query matched on parent menu item
          item.isHighlighted = true;
        }
        return item;
      });
    }
    return highlightedMenuItems;
  }, [menuItems, searchValue]);
  return (
    /*#__PURE__*/
    /** Use className for menu states because props can not be added to Item as Link */
    /** On search the menu items are faded except the highlighted item */
    _react["default"].createElement(MenuS.Wrapper, {
      isOpen: isOpen,
      className: "".concat(isOpen ? " is-menu-open" : "").concat(searchValue ? " is-search-value" : "")
    }, logo && /*#__PURE__*/_react["default"].createElement(logo, {
      isOpen: isOpen,
      onClick: toggleMenu
    }), hasSearch && /*#__PURE__*/_react["default"].createElement(_MenuSearch["default"], {
      isMenuOpen: isOpen,
      openMenu: openMenu,
      onSearch: function onSearch(s) {
        return setSearchValue(s);
      }
    }), /*#__PURE__*/_react["default"].createElement(_MenuItemsList["default"], {
      menuItems: displayItems,
      isMenuOpen: isOpen,
      openMenu: openMenu,
      isSearchValue: !!searchValue,
      searchValue: searchValue
    }), hasLogoutButton && /*#__PURE__*/_react["default"].createElement(_LogoutMenuItem["default"], {
      logout: logout
    }), /*#__PURE__*/_react["default"].createElement(MenuS.Footer, {
      onClick: toggleMenu
    }, /*#__PURE__*/_react["default"].createElement(_ToggleMenuItem["default"], {
      isOpen: isOpen
    })), (whiteLabel === null || whiteLabel === void 0 ? void 0 : whiteLabel.src) && /*#__PURE__*/_react["default"].createElement(_WhiteLabel["default"], {
      isOpen: isOpen,
      labelDetails: whiteLabel
    }))
  );
};
Menu.propTypes = propTypes;
var _default = Menu;
exports["default"] = _default;